var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thanks-view view row justify-content-center align-items-center"},[_c('div',{staticClass:"col-11 col-sm-6 col-lg-5 col-xl-4 text-center"},[_c('h2',{staticClass:"text-uppercase mb-5"},[_vm._v(_vm._s(_vm.$t('shared_thanks.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('shared_thanks.body')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }